import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import { Translations_EN } from "./en/translations"
import { Translations_HU } from "./hu/translations"
import { Translations_DE } from "./de/translations"
import { Translations_UA } from "./ua/translations"
import { Translations_AT } from "./at/translations"
import { Translations_NL } from "./nl/translations"
import { Translations_MK } from "./mk/translations"
import { Translations_PT } from "./pt/translations"
import { Translations_ES } from "./es/translations"
import { Translations_NO } from "./no/translations"
import { Translations_RO } from "./ro/translations"
import { Translations_CN } from "./cn/translations"
import { Translations_FR } from "./fr/translations"
import { Translations_IT } from "./it/translations"
import { Translations_CZ } from "./cz/translations"
import { Translations_SK } from "./sk/translations"
import { Translations_RU } from "./ru/translations"
import { Translations_HE } from "./he/translations"
import { Translations_AR } from "./ar/translations"

i18n.use(initReactI18next).init({
	defaultNS: 'translation',
	lng: 'en',
	interpolation: {
		escapeValue: false
	},
	fallbackLng:'en',
	returnEmptyString: false,
	resources: {},
	resources: {
		en: {
			translation: Translations_EN
		},
		hu: {
			translation: Translations_HU
		},
		de: {
			translation: Translations_DE
		},
		ua: {
			translation: Translations_UA
		},
		at: {
			translation: Translations_AT
		},
		nl: {
			translation: Translations_NL
		},
		mk: {
			translation: Translations_MK
		},
		pt: {
			translation: Translations_PT
		},
		es: {
			translation: Translations_ES
		},
		no: {
			translation: Translations_NO
		},
		ro: {
			translation: Translations_RO
		},
		cn: {
			translation: Translations_CN
		},
		fr: {
			translation: Translations_FR
		},
		it: {
			translation: Translations_IT
		},
		cz: {
			translation: Translations_CZ
		},
		sk: {
			translation: Translations_SK
		},
		ru: {
			translation: Translations_RU
		},
		he: {
			translation: Translations_HE
		},
		ar: {
			translation: Translations_AR
		},
	}
})

export default i18n
